jQuery(document).ready(function ($) {
  //############################################//
  //###*****   Component - Desktop Menu
  //###*****   Use with styles /styles/components/site-nav.scss
  //############################################//

  const mqd = window.matchMedia('(min-width: 1280px)');
  const mqm = window.matchMedia('(mxn-width: 1279px)');
  if (mqd.matches) {
    $('a.c-site-nav__link').each(function () {
      $(this)
        .siblings('.c-site-nav__dropdown')
        .find('.c-site-nav__dropdown-label')
        .html($(this).html());

      // $(this).find('.c-site-nav__dropdown-label').text($(e.currentTarget).text())

      // var $htmlStr = $(this).clone();
      // console.log($htmlStr);
      // $(this)$htmlStr.appendTo(".c-site-nav__dropdown-label");
      var $href = $(this).attr('href');
      // $(this)
      //   .siblings(".c-site-nav__dropdown")
      //   .find(".c-site-nav__dropdown-label")
      //   .prepend(
      //     '<a href="' +
      //       $href +
      //       '" class="c-site-nav__view-all c-button"><span>Browse category</span></a>'
      //   );
    });

    //Add matching classes to Parent and submenu container
    $('.c-site-nav__link').each(function (i) {
      // var $label = $(this).clone();
      // console.log($label);
      // $(this).siblings(".c-site-nav__dropdown").prepend($label);

      // $(this)
      //   .siblings(".c-site-nav__dropdown")
      //   .find(".c-site-nav__dropdown--wide-list")
      //   .prepend($label);
      $(this)
        .siblings('.c-site-nav__dropdown')
        .addClass('menu--' + i);
      //   $(this)
      //     .find(".level2")
      //     .addClass("menu--" + i);
      $(this).attr('id', 'menu--' + i);
    });

    // $(".c-site-nav__item").each(function () {

    //   $(this + '.cols-3').

    // });

    //Menu on click
    $('.c-site-nav__link').each(function () {
      $(this).click(function (e) {
        e.preventDefault();
        console.log('clicked');
        //Remove other states
        $('.c-site-nav__item').removeClass('is-active');
        $('.c-site-nav__dropdown').hide().removeClass('is-active');
        $('body').removeClass(' overflow-y-scroll');
        // Then show the ones that match this `id`
        $('.' + this.id)
          .show()
          .addClass('is-active');
        $(this).closest('.c-site-nav__item').addClass('is-active');
        $('body').addClass('overflow-y-hidden');
      });
    });

    //Move all the dropdown elements to containing element
    $('.c-site-nav__item .c-site-nav__dropdown').each(function () {
      $(this).appendTo('.c-site-nav__dropdown-wrapper');
    });

    //Wrapping sub menus
    $('.c-site-nav__dropdown--wide-list').each(function () {
      $(this)
        .find('.column-group-1')
        .wrapAll("<div class='column-wrapper--group-1'></div>");
      $(this)
        .find('.column-group-2')
        .wrapAll("<div class='column-wrapper--group-2'></div>");
      $(this)
        .find('.column-group-3')
        .wrapAll("<div class='column-wrapper--group-3'></div>");
      $(this)
        .find('.column-group-4')
        .wrapAll("<div class='column-wrapper--group-4'></div>");
      $(this)
        .find('.column-group-5')
        .wrapAll("<div class='column-wrapper--group-5'></div>");
      $(this)
        .find('.column-group-6')
        .wrapAll("<div class='column-wrapper--group-6'></div>");
    });

    //Add submenu panel close
    $('.c-site-nav__dropdown-label').prepend(
      '<div class="c-site-nav__close-panel js-close-dropdown"><span>Close</span></div>'
    );
    $('.js-close-dropdown').click(function () {
      $('.c-site-nav__dropdown').hide().removeClass('is-active');
      $('.c-site-nav__link').removeClass('is-active');
      $('body').removeClass('overflow-y-hidden');
    });

    var href = $(this).attr('href');
    $('.c-site-nav__dropdown-all-link').prepend(
      '<div class="c-site-nav__close-panel js-close-dropdown absolute right-6 border-l border-solid cursor-pointer border-penketh_black mt-1"><span class="text-10 font-heading uppercase pl-4">Close</span></div>'
    );
  } else if (mqm.matches) {
  }
});
